import { useQuery } from '@tanstack/react-query';
import { IMMIGRATION_STATUS_KEY } from '../../utils/constants/queryKeys';
import { getImmigrationStatusInfo } from '../services/fn-api/ImmigrationStatus';

export const useGetImmigrationStatusInfo = (beneId: number | undefined, dependentId: number | undefined) => {
  return useQuery({
    queryKey: [IMMIGRATION_STATUS_KEY, beneId, dependentId],
    queryFn: () => getImmigrationStatusInfo(beneId, dependentId),
    enabled: !!beneId || !!dependentId,
  });
};
